import { cn } from '@/lib/cn'

export type BurgerButtonProps = {
  open?: boolean
} & React.ButtonHTMLAttributes<HTMLButtonElement>

export default function BurgerButton({ open, className, ...rest }: BurgerButtonProps) {
  const strokeStyle = cn('w-6 h-[2px] bg-text absolute transition-all duration-300', {
    'bg-surface-solid': open,
  })

  return (
    <button className={cn('group p-3', className)} {...rest}>
      <span
        className={cn(
          'relative size-6 flex items-center justify-center transition-transform duration-200',
          {
            'rotate-90': open,
          },
        )}
      >
        <span className='sr-only'>{'Toggle menu'}</span>
        <span
          aria-hidden
          className={cn(strokeStyle, '-translate-y-[5px]', { 'rotate-45 translate-y-0': open })}
        />
        <span aria-hidden className={cn(strokeStyle, { 'rotate-45': open })} />
        <span
          aria-hidden
          className={cn(strokeStyle, 'translate-y-[5px]', { '-rotate-45 translate-y-0': open })}
        />
      </span>
    </button>
  )
}
